var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spofaq-searchapp__result-posts",attrs:{"role":"region"}},[_vm._l((_vm.posts),function(post){return [_c('Post',{key:post.id,attrs:{"post":post,"open":_vm.isOpen},on:{"toggled":_vm.toggleDetails}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }